module.exports = __webpack_public_path__ + "static/media/dotsicon.96019648.svg";